import { useEffect, useState } from 'react';
import { MONITOR_CLOCK_INTERVAL } from '../constants';

const getMinutesSince = (timestamp: number) =>
  timestamp > 0
    ? Math.floor((Date.now() - timestamp) / MONITOR_CLOCK_INTERVAL)
    : 0;

export const useMinutesSince = (timestamp: number) => {
  const [minutesSince, setMinutesSince] = useState(() =>
    getMinutesSince(timestamp),
  );

  useEffect(() => {
    setMinutesSince(getMinutesSince(timestamp));

    if (timestamp <= 0) {
      return undefined;
    }

    const intervalId = window.setInterval(
      () => setMinutesSince(getMinutesSince(timestamp)),
      MONITOR_CLOCK_INTERVAL,
    );

    return () => window.clearInterval(intervalId);
  }, [timestamp]);

  return minutesSince;
};
